module.exports = __webpack_public_path__ + "static/media/Deposit.0361e065.svg";